import { ReviewEntityType, ReviewStatus } from './types';
export const ReviewEntityUtils = {
    isPendingReview(reviewEntity) {
        return [ReviewStatus.PENDING, ReviewStatus.IN_REVIEW].includes(reviewEntity?.status);
    },
    getLatestReview(reviewEntity) {
        return reviewEntity?.reviews?.[reviewEntity.reviews?.length - 1];
    },
};
export const SupportedRPEntityTypes = Object.keys({
    [ReviewEntityType.EP_WRITTEN_ANSWER]: true,
    [ReviewEntityType.EP_ORALS_ANSWER]: true,
    [ReviewEntityType.EP_WRITTEN_QP]: true,
    [ReviewEntityType.EP_ORALS_QP]: true,
    [ReviewEntityType.EP_EXAMINERS_FEEDBACK]: true,
    [ReviewEntityType.EP_EXAMINERS_FEEDBACK_IMAGES]: true,
}).map(Number);
